/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { Grid, Typography } from '@material-ui/core';

import { asgardeoConsoleUrl, choreoConsoleUrl } from 'config';
import { FormattedMessage } from 'react-intl';
import { PRODUCT_NAME } from 'pages/constants';
import { useStyles } from './styles';

export default function DirectVisitWarning() {
  const classes = useStyles();

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      className={classes.pageContainer}
    >
      <Grid item xs={12} lg={4} className={classes.directVisitWarningTitle}>
        <Typography
          variant="h2"
          className={classes.text}
          data-testid="direct-visit-warning-title"
        >
          <FormattedMessage
            id="pages.directVisitWarning.title"
            defaultMessage="Looks like you want to access the WSO2 Billing Portal."
          />
        </Typography>
        <br />
      </Grid>
      <Grid
        item
        xs={12}
        lg={4}
        data-testid="direct-visit-warning-description"
        className={classes.directVisitWarningDescription}
      >
        <FormattedMessage
          id="pages.directVisitWarning.description"
          defaultMessage={
            'Sign in to the {asgardeoConsole} (if you are a WSO2 Identity Platform user) or the {choreoConsole}' +
            ' (if you are a {productName} user), and access the Billing Portal from there.'
          }
          values={{
            productName: PRODUCT_NAME,
            choreoConsole: (
              <a href={choreoConsoleUrl} data-testid="choreo-console-url">
                <FormattedMessage
                  id="pages.directVisitWarning.redirectLink.label.choreo"
                  defaultMessage="{productName} Console"
                  values={{ productName: PRODUCT_NAME }}
                />
              </a>
            ),
            asgardeoConsole: (
              <a href={asgardeoConsoleUrl} data-testid="asgardeo-console-url">
                <FormattedMessage
                  id="pages.directVisitWarning.redirectLink.label.asgardeo"
                  defaultMessage="WSO2 Identity Platform Console"
                />
              </a>
            ),
          }}
          tagName="span"
        />
      </Grid>
    </Grid>
  );
}
